import styled from 'styled-components';
export const DisabledContainer = styled.div.withConfig({
  displayName: "DisabledContainer",
  componentId: "sc-1gvejrb-0"
})(["cursor:not-allowed;"]);